import React, { useState } from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import BrandLoader from './BrandLoader';

const LoaderTest = () => {
  const [activeLoader, setActiveLoader] = useState(null);

  const loaderTypes = [
    { type: 'logo', name: 'Logo Spinner', description: 'Rotates your logo' },
    { type: 'dots', name: 'Brand Dots', description: '3 animated dots' },
    { type: 'wave', name: 'Brand Wave', description: '5-dot wave animation' },
    { type: 'pulse', name: 'Brand Pulse', description: 'Pulsing circle' },
    { type: 'spinner', name: 'Brand Spinner', description: 'Circular spinner' },
    { type: 'text', name: 'Brand Text', description: 'Animated NIStylez text' }
  ];

  const sizes = ['small', 'medium', 'large'];

  return (
    <Box sx={{ p: 4, maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
        BrandLoader Test Page
      </Typography>

      {/* Test All Types */}
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
        All Loader Types
      </Typography>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {loaderTypes.map((loader) => (
          <Grid item xs={12} sm={6} md={4} key={loader.type}>
            <Paper sx={{ p: 3, textAlign: 'center', height: '100%' }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
                {loader.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {loader.description}
              </Typography>
              <Box sx={{ mb: 2, minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <BrandLoader 
                  type={loader.type} 
                  size={loader.type === 'logo' ? 'large' : 'medium'} 
                  showText={false}
                />
              </Box>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setActiveLoader(activeLoader === loader.type ? null : loader.type)}
              >
                {activeLoader === loader.type ? 'Hide' : 'Show'} with Text
              </Button>
              {activeLoader === loader.type && (
                <Box sx={{ mt: 2 }}>
                  <BrandLoader type={loader.type} size="medium" showText={true} />
                </Box>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Test Different Sizes */}
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
        Different Sizes
      </Typography>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {sizes.map((size) => (
          <Grid item xs={12} sm={4} key={size}>
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', textTransform: 'capitalize' }}>
                {size} Size
              </Typography>
              <Box sx={{ mb: 2, minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <BrandLoader type="dots" size={size} showText={true} />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Test Logo Spinner Sizes */}
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
        Logo Spinner - Different Sizes
      </Typography>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {sizes.map((size) => (
          <Grid item xs={12} sm={4} key={size}>
            <Paper sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', textTransform: 'capitalize' }}>
                {size} Logo
              </Typography>
              <Box sx={{ mb: 2, minHeight: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <BrandLoader type="logo" size={size} showText={true} />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Test Logo Spinner (Current Implementation) */}
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
        Current Implementation (Logo Spinner)
      </Typography>
      <Paper sx={{ p: 4, textAlign: 'center', backgroundColor: '#f5f5f5' }}>
        <Typography variant="h6" sx={{ mb: 3 }}>
          This is what you'll see in the Featured Services section:
        </Typography>
        <Box sx={{ mb: 3, minHeight: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <BrandLoader type="logo" size="large" showText={true} />
        </Box>
        <Typography variant="body2" color="text.secondary">
          Your logo will spin with brand colors and "Loading..." text
        </Typography>
      </Paper>

      {/* Instructions */}
      <Paper sx={{ p: 3, mt: 4, backgroundColor: '#e3f2fd' }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
          Testing Instructions:
        </Typography>
        <Typography variant="body2" component="div">
          1. <strong>Logo Spinner:</strong> Make sure you have a logo.png file in your public folder<br/>
          2. <strong>Brand Colors:</strong> All loaders use your NIStylez colors (#667eea, #764ba2)<br/>
          3. <strong>Performance:</strong> These are pure CSS animations - no GIFs!<br/>
          4. <strong>Responsive:</strong> All loaders scale properly on mobile and desktop
        </Typography>
      </Paper>
    </Box>
  );
};

export default LoaderTest;
